export const POLICY = {
  DRIVER: {
    LOCATION: '/policies/driver-location',
    TRANSPORT: '/policies/driver-transport',
    COLLECTION_PERSONAL_INFO: '/policies/driver-collection-personal-info',
    PROVIDING_LOCATION_INFO_THIRD_PARTIES: '/policies/driver-providing-location-info-third-parties',
    PROVIDING_PERSONAL_INFO_THIRD_PARTIES: '/policies/driver-providing-personal-info-third-parties',
  },
  OWNER: {
    TRANSPORT: '/policies/owner-transport',
  },
  ADVERTISE: '/policies/advertise',
  MARKETING: '/policy/marketing-utilization',
  SERVICE: '/policies/service',
  PERSONAL: {
    PRIVACY: '/policies/privacy',
  },
}

export const POLICY_TAB_TYPE = [
  {
    label: '이용약관',
    url: POLICY.SERVICE,
  },
  {
    label: '운송약관',
    url: POLICY.OWNER.TRANSPORT,
  },
  {
    label: '개인정보 처리방침',
    url: POLICY.PERSONAL.PRIVACY,
  },
  {
    label: '위치기반 서비스약관',
    url: POLICY.DRIVER.LOCATION,
  },
]
